// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Index_wrapper__NuUSz","titleWrapper":"Index_titleWrapper__UymEn","button":"Index_button__RsieF","tellUs":"Index_tellUs__WKtGK","cardBlocks":"Index_cardBlocks__KwCMm"};